<template>
  <div v-if="seller" id="update-register-info-page">
    <div class="update-note">
      ご利用者様の適正管理のため、ご登録情報の更新をお願いいたします。
    </div>
    <div class="box-steps">
      <div class="step-name text-center m-b-sm">STEP {{ currentStep }}/2</div>
      <div v-show="currentStep === 1" class="step-one bg-white">
        <div class="item item-country">
          <div class="item-label">国</div>
          <div class="item-content">{{ seller.countryName }}</div>
        </div>
        <div class="item item-corporate-kbn">
          <div class="item-label">
            <div class="label-title">法人 / 個人</div>
            <div class="label-required">必須</div>
          </div>
          <div class="item-content item-options">
            <div v-for="options in corporateKbnOptions" :key="options.id" :class="['option', options.id === corporateKbn ? 'selected' : '']" @click="corporateKbn = options.id">
              <div class="option-icon"></div><div class="option-name">{{ options.name }}</div>
            </div>
          </div>
        </div>
        <div class="box-step-action">
          <button type="button" class="btn btn-info btn-next-step" :disabled="disableNextStepOne" @click.prevent="handleNextStepOne()">次へ</button>
        </div>
      </div>
      <div v-if="currentStep === 2" class="step-two bg-white m-t-md">
        <japan-corporation-update-page
          v-if="isJapanUser && corporateIds.includes(corporateKbn)"
          :seller="seller"
          @back="handlePrevStepOne"
          @handleSubmit="openUpdateConfirmModal"
        />
        <japan-individual-update-page
          v-if="isJapanUser && individualIds.includes(corporateKbn)"
          :seller="seller"
          @back="handlePrevStepOne"
          @handleSubmit="openUpdateConfirmModal"
        />
        <china-corporation-update-page
          v-if="!isJapanUser && corporateIds.includes(corporateKbn)"
          :seller="seller"
          @back="handlePrevStepOne"
          @handleSubmit="openUpdateConfirmModal"
        />
        <china-individual-update-page
          v-if="!isJapanUser && individualIds.includes(corporateKbn)"
          :seller="seller"
          @back="handlePrevStepOne"
          @handleSubmit="openUpdateConfirmModal"
        />
      </div>
    </div>
    <div class="box-btn-skip-register-info m-t">
      <button type="button" class="btn btn-skip-register-info" @click.prevent="handleSkipRegisterInfo()">Skip</button>
    </div>

    <update-confirm-modal
      v-if="showUpdateConfirmModal"
      :message="`入力した内容で登録してもよろしいですか？`"
      @close="closeUpdateConfirmModal"
      @confirm="handleUpdateRegisterInfo"
    />
    <update-completed-modal
      v-if="showUpdateCompletedModal"
      @close="handleCloseCompletedModal"
    />
  </div>
</template>

<script>
import JapanCorporationUpdatePage from '@/view/updateRegisterInfo/JapanCorporation'
import JapanIndividualUpdatePage from '@/view/updateRegisterInfo/JapanIndividual'
import ChinaCorporationUpdatePage from '@/view/updateRegisterInfo/ChinaCorporation'
import ChinaIndividualUpdatePage from '@/view/updateRegisterInfo/ChinaIndividual'
import UpdateCompletedModal from '@/view/updateRegisterInfo/ModalUpdateCompleted'
import UpdateConfirmModal from '@/components/ModalConfirm'
import UserService from '@/services/userservice'
import SettingService from '@/services/settingservice'

export default {
  components: {
    JapanCorporationUpdatePage,
    JapanIndividualUpdatePage,
    ChinaCorporationUpdatePage,
    ChinaIndividualUpdatePage,
    UpdateConfirmModal,
    UpdateCompletedModal
  },
  data () {
    return {
      corporateKbnOptions: [
        {
          id: 1,
          name: '上場企業（法人）'
        },
        {
          id: 2,
          name: '非上場企業（法人）'
        },
        {
          id: 3,
          name: 'チャリティ企業（法人）'
        },
        {
          id: 4,
          name: '個人事業主'
        },
        {
          id: 5,
          name: '個人'
        }
      ],
      showUpdateConfirmModal: false,
      showUpdateCompletedModal: false,
      currentStep: 1,
      corporateKbn: null,
      availablecorporateKbnOptions: [1, 2, 3, 4, 5],
      corporateIds: [1, 2, 3],
      individualIds: [4, 5],
      stateList: [],
      loader: null,
      formData: null,
      seller: null
    }
  },
  computed: {
    isJapanUser () {
      return this.seller.countryCode === 'jp'
    },
    disableNextStepOne () {
      return !this.corporateKbn || !this.availablecorporateKbnOptions.includes(this.corporateKbn)
    },
    storageSkipShowRegisterInfoName () {
      return `${this.seller.sellerId}-SkipShowRegisterInfo`
    }
  },
  created () {
    this.getSellerInfo()
  },
  methods: {
    handleNextStepOne () {
      if (this.disableNextStepOne) {
        return false
      }
      this.currentStep = 2
    },
    handlePrevStepOne () {
      this.currentStep = 1
    },
    openUpdateConfirmModal (formData) {
      this.showUpdateConfirmModal = true
      this.formData = formData
      this.formData['corporateKbn'] = String(this.corporateKbn)
      this.formData['invoiceRegistrationKbn'] = String(this.formData['invoiceRegistrationKbn'])
    },
    closeUpdateConfirmModal () {
      $('#confirm-alert').modal('hide')
      this.showUpdateConfirmModal = false
    },
    openUpdateCompletedModal () {
      this.showUpdateCompletedModal = true
    },
    handleCloseCompletedModal () {
      $('#modal-update-completed').modal('hide')
      this.showUpdateCompletedModal = false
      this.$router.push('/home')
    },
    handleUpdateRegisterInfo () {
      this.closeUpdateConfirmModal()

      this.loader = this.$loading.show()
      UserService.updateRegisterInfo({ form_data: this.formData })
        .then(response => {
          this.loader && this.loader.hide()
          this.formData = null
          this.openUpdateCompletedModal()
          this.$store.commit('setSellerUpdatedRegisterInfo', '1') // 更新済
        })
        .catch(err => {
          this.formData = null
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: err
          })
        })
    },
    async getSellerInfo () {
      await SettingService.getSellerInformation()
        .then(response => {
          this.seller = response.seller
          this.corporateKbn = parseInt(response.seller.corporateKbn)
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    handleSkipRegisterInfo () {
      localStorage.setItem(this.storageSkipShowRegisterInfoName, true)
      setTimeout(() => {
        this.$router.push('/home')
      }, 300)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/updateRegisterInfo/UpdateRegisterInfo.vue